import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ConfirmationDialog extends MatDialogDataBaseInput {
	title: string;
	description: string;
	okText: string;
	cancelText: string;
}

export interface DialogData_ConfirmationDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-confirmation-dialog",
	templateUrl: "./confirmation-dialog.component.html",
	styleUrls: ["./confirmation-dialog.component.scss"],
	standalone: false,
})
export class ConfirmationDialogComponent extends BasicMaterialDialog<
	ConfirmationDialogComponent,
	DialogData_ConfirmationDialog,
	DialogData_ConfirmationDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
